import React from 'react';
import {
  CAROUSEL_HEIGHT,
  CatalogCarouselItemsLoading,
  IMAGE_SIZE,
  RADIUS,
} from '@/components/catalog-carousel-items-loading';
import { createStyles } from '@/contexts/theme-context';
import { LIST_MARGIN_HORIZONTAL_LARGE } from '@/components/horizontal-list';
import { SCREEN_PADDING_LARGE, SCREEN_PADDING_SMALL } from '@/styles';
import { Skeleton } from 'react-native-skeletons';
import { SkeletonText } from '@/components/skeleton-text';
import { useLayoutContext } from '@/contexts/layout-context';
import { useWindowDimensions, View } from 'react-native';

export const CatalogCarouselsLoading: React.FC = () => {
  const [styles] = useStyles();
  const dimensions = useWindowDimensions();
  const { isSmallLayout } = useLayoutContext();

  const maxHeightLoadingSkeletons = Math.ceil(
    dimensions.height / CAROUSEL_HEIGHT,
  );

  return (
    <>
      {[...new Array(maxHeightLoadingSkeletons)].map((_, i) => (
        <View key={i} style={styles.base}>
          <View
            style={[
              styles.row,
              isSmallLayout ? styles.titleRowSmall : styles.titleRowLarge,
            ]}
          >
            {!isSmallLayout ? (
              <Skeleton
                borderRadius={RADIUS}
                height={IMAGE_SIZE}
                width={IMAGE_SIZE}
              />
            ) : null}
            <View style={styles.titleContainer}>
              <SkeletonText height={16} />
            </View>
          </View>
          <View
            style={isSmallLayout ? styles.itemsRowSmall : styles.itemsRowLarge}
          >
            <CatalogCarouselItemsLoading />
          </View>
        </View>
      ))}
    </>
  );
};

const useStyles = createStyles(() => ({
  base: {
    marginBottom: 24,
  },
  itemsRowLarge: {
    marginHorizontal: LIST_MARGIN_HORIZONTAL_LARGE,
  },
  itemsRowSmall: {
    paddingHorizontal: SCREEN_PADDING_SMALL,
  },
  row: {
    flexDirection: 'row',
    gap: 16,
  },
  titleContainer: {
    flex: 1,
  },
  titleRowLarge: {
    alignItems: 'center',
    marginBottom: 24,
    marginHorizontal: SCREEN_PADDING_LARGE,
    width: '20%',
  },
  titleRowSmall: {
    marginBottom: 12,
    marginHorizontal: SCREEN_PADDING_SMALL,
    width: '70%',
  },
}));
